/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function ERUpdate() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="Election Readiness Update - October 2026"
              description={
               <>
               <h4>Election Readiness Update - October 2026</h4>
                  <br />
                  <p>Without a fixed-date election cycle, Elections Nova Scotia (ENS) must continually prepare to be election ready when called upon. To achieve this, we rely on a planning cycle with key election readiness gates in April and September of each year. To enhance transparency and keep Nova Scotians informed of our election readiness plans, we publish updates throughout our readiness cycle. The October 2026 Election Readiness Update is the first report on planning for the 43<sup>rd</sup> Provincial General Election (PGE). </p>
                  <br />
                  <p>As we work through the election readiness cycle for the 43<sup>rd</sup> PGE, ENS will continue to provide updates on our progress at key readiness gates. Careful election readiness planning ensures ENS is prepared to successfully deliver the free, fair, and accessible election that Nova Scotians expect and deserve whenever it is called.</p>
                  <br />
                  <p> <u><a href="/files/AnnualAndOtherReports/ERUpdateReport_FINAL_Oct2026.pdf">Election Readiness Update October 2026</a></u> </p>
               </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default ERUpdate;
